import { CardStyle, ShrinkConfig, SiderStyle } from '../../types';

export enum ShrinkType {
  FullShrink = 'fullShrink',
  ShrinkToWith = 'shrinkToWith',
}

export type StyleConfig = {
  cardStyle: CardStyle;
  style: SiderStyle;
  width?: number;
  shrink?: ShrinkConfig;
};

/**
 * 布局页面中，触发缩放的来源
 */
export enum ShrinkTrigger {
  /** 侧边栏按钮控制 */
  Button = 'Side_Btn',
}

export enum DropMode {
  Single = 'single',
  More = 'more',
}

export type RenderComsOptions = {
  needRelayout?: boolean;
  margin?: number[];
  containerPadding?: [];
};

/** layoutsider.shrink 回调的参数类型 */
export type ShrinkData = {
  enabled?: boolean;
  defaultMode?: boolean | string;
  minWidth?: string;
  type?: ShrinkType;
  shrinkWidth?: string;
  showShrink: boolean;
};

export default {};
